import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import vis from "vis";
import "vis-timeline/dist/vis-timeline-graph2d.min.css";

const TimeLineComponent = (props) => {
  const [timeLineItems, setTimeLineItems] = useState([]);
  const [unit, setUnit] = useState("");
  /*if (props.modalParam) {
    let items = [];
    for (let i = 0; i < seriesList.length; i++) {
      let yValue = props.graphData.nodes.filter((l) => l.id === seriesList[i])[0].properties.seriesDataPointValue;
      if (typeof yValue === "string") {
        let hour = parseInt(yValue.replace("h ", ":").replace("m", "").split(":")[0]);
        let min = parseInt(yValue.replace("h ", ":").replace("m", "").split(":")[1]);
        var value = 60 * hour + min;
      } else {
        value = yValue;
      }
      items.push({
        x: props.graphData.nodes.filter((l) => l.id === seriesList[i])[0].properties.seriesDataPointTime,

        y: value,
      });
    }
  }*/

  useEffect(() => {
    if (props.timeLineItems.metaArray._type.includes("weight")) {
      setTimeLineItems(
        props.timeLineItems.metaArray.items.map((k) => {
          return { x: k.key, y: k.value };
        }),
      );
      setUnit("kg");
    }

    if (props.timeLineItems.metaArray._type.includes("heartRate")) {
      let array1 = props.timeLineItems.metaArray.items.map((k) => {
        return { x: k.key, y: k.value.max, group: 1 };
      });
      let array2 = props.timeLineItems.metaArray.items.map((k) => {
        return { x: k.key, y: k.value.resting, group: 2 };
      });

      let array3 = array1.concat(array2);
      setTimeLineItems(array3);
      setUnit("bpm");
    }
  }, [props.timeLineItems]);

  useEffect(() => {
    if (timeLineItems.length > 0) {
      var container = document.getElementById("visualization");
      var dataset = new vis.DataSet(timeLineItems);
      var dates = timeLineItems.map((k) => {
        return k.x;
      });
      var options = {
        start: dates[0],
        end: dates[dates.length - 1],
        moveable: false,
        zoomable: false,
        timeAxis: { scale: "weekday", step: 1 },
        dataAxis: {
          left: {
            title: {
              text: unit,
              style: "color: #ffffff",
            },
          },
        },
        drawPoints: {
          style: "circle", // square, circle
        },
        shaded: {
          orientation: "bottom", // top, bottom
        },
      };

      var graph2d = new vis.Graph2d(container, dataset, options);
    }
  }, [timeLineItems]);

  return (
    <>
      <div id="visualization"></div>
    </>
  );
};

export default TimeLineComponent;
